import {
  IDatabaseTableModel,
  IGenericSelectCalculatedField,
  IGenericSelectTablesModel,
  IGenericSelectWhereConditionModel,
  IGenericSelectWhereDataModel
} from "@kuika/kuika-cl-model";
import {
  EManagedDbUpdateWhereConditionOperator,
  ESymbolCategory,
  ISymbol
} from "@kuika/kuika-cl-model/src/models/builder.dtos";
import classNames from "classnames";
import _ from "lodash";
import * as React from "react";
import KuikaBadge from "../../../../ui-kit/kuika-badge/kuika-badge";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTextMedium from "../../../../ui-kit/typography/TextMedium/TextMedium";
import { FilterSelectGroupComponent } from "./filter-select-group";

export interface IFilterOrGroupState {}

export interface IFilterOrGroupProps {
  tables: IDatabaseTableModel[];
  selectedTables: IGenericSelectTablesModel[];
  calculatedFields: IGenericSelectCalculatedField[];
  hasMoreData: boolean;
  data: IGenericSelectWhereDataModel;
  updateData: (newData: IGenericSelectWhereDataModel) => void;
  getTypeIcon: (type: string) => React.ReactElement;
}

class FilterOrGroup extends React.PureComponent<IFilterOrGroupProps, IFilterOrGroupState> {
  constructor(props: IFilterOrGroupProps) {
    super(props);
    this.state = {};
  }

  handleClickAddOr = () => {
    const data = _.cloneDeep(this.props.data);
    const condition: IGenericSelectWhereConditionModel = {
      tableSchema: "",
      tableName: "",
      colName: "",
      colSqlDataType: "",
      conditionOperator: EManagedDbUpdateWhereConditionOperator.isEqualTo,
      paramSymbol: { category: ESymbolCategory.fixed } as ISymbol
    };

    data.orConditions!.push(condition);

    this.props.updateData(data);
  };

  handleDeleteOr = (idx: number) => {
    const data = _.cloneDeep(this.props.data);
    data.orConditions!.splice(idx, 1);
    this.props.updateData(data);
  };

  handleUpdateData = (newData: IGenericSelectWhereConditionModel, idx: number) => {
    const data = _.cloneDeep(this.props.data);
    data.orConditions![idx] = newData;
    this.props.updateData(data);
  };

  render() {
    return (
      <div
        className={classNames("filter-or-group-wrapper", { "filter-or-group__with-and-svg": this.props.hasMoreData })}
      >
        <KuikaTextMedium className="filter-or-group__title">OR GROUP</KuikaTextMedium>
        <div className="filter-or-group__content">
          {this.props.data.orConditions?.map((orData, idx) => {
            const hasMoreOrData = this.props.data.orConditions!.length - 1 > idx;
            return (
              <div key={idx} className="filter-or-condition-item">
                <FilterSelectGroupComponent
                  type="or"
                  tables={this.props.tables}
                  selectedTables={this.props.selectedTables}
                  calculatedFields={this.props.calculatedFields}
                  data={orData}
                  updateData={(newData) => this.handleUpdateData(newData, idx)}
                  hasMoreData={false}
                  delete={() => this.handleDeleteOr(idx)}
                  getTypeIcon={this.props.getTypeIcon}
                />
                {hasMoreOrData && (
                  <div className="filter-connector filter-connector--or">
                    <div className="filter-connector__line" />
                    <KuikaBadge content="OR" color="grey" />
                    <div className="filter-connector__line" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <KuikaButton type="text" onClick={this.handleClickAddOr}>
          <KuikaSvg name="plus" width={16} height={16} />
          OR
        </KuikaButton>
      </div>
    );
  }
}

export const FilterOrGroupComponent = FilterOrGroup;
